<ix-modal-header>
  {{ 'um.access_requests.decline_modal_title' | translate }}
</ix-modal-header>

<ix-modal-content>
  <ix-typography class="d-block mb-3" format="body">
    {{ 'um.access_requests.decline_modal_warning' | translate }}
  </ix-typography>

  <ix-typography class="d-block mb-3" format="body" textColor="soft">
    {{ 'um.access_requests.decline_modal_reason_intro' | translate }}
  </ix-typography>

  <ix-textarea
    textareaWidth="100%"
    [maxLength]="500"
    class="w-100"
    [label]="'um.access_requests.decline_modal_reason_label' | translate"
    [placeholder]="'um.access_requests.decline_modal_reason_placeholder' | translate"
    [(ngModel)]="reason"
    resizeBehavior="none"
    id="declineReasonInput">
  </ix-textarea>
</ix-modal-content>

<ix-modal-footer>
  <ix-button
    class="dismiss-modal"
    onkeypress=""
    variant="danger-secondary"
    (click)="activeModal.dismiss('cancel')"
    id="declineModalCancelButton">
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    variant="danger-primary"
    (click)="confirm()"
    onkeypress=""
    id="declineModalConfirmButton">
    {{ 'um.access_requests.decline_access' | translate }}
  </ix-button>
</ix-modal-footer>

